import { resolveMediaUrl } from './mediaUrl';

export const parseSolutionsAdvantageContent = (page) => {
  if (!page?.sections?.length) {
    return null;
  }

  const section = page.sections.find((item) => item.key === 'advantage');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  const eagleMedia = section.media?.groups?.eagle?.[0] || null;

  if (!fields.title || !fields.text || !eagleMedia?.url) {
    return null;
  }

  return {
    title: fields.title,
    text: fields.text,
    eagle: resolveMediaUrl(eagleMedia.url),
  };
};
